































































































































import {
	AccountTypeEnum,
	CatalogueItemModel,
	FrequencyEnum,
	PartyModel, TenantModel,
	TenantUserModel,
	VisitRuleModel,
	WorkTaskRuleModel,
	WorkTaskStatementModel
} from '@/libs/Api';
import Page from '@/Page.vue';
import {Component, Prop, Ref, Watch} from 'vue-property-decorator';
import {partiesStore} from '@/libs/parties/+state/store';
import {CrudGetter} from '@/libs/core/+state/models/crud-getter';
import {catalogueItemsStore} from '@/libs/catalogue-items/+state/store';
import {CrudAction, CrudReponse} from '@/libs/core/+state/models/crud-action';
import {createCrudQueryPayload} from '@/libs/core/+state/models/crud-query-payload';
import {workTaskRulesStore} from '@/libs/work-task-rules/+state/store';
import {Guid} from '@/libs/common/functions/guid';
import {authStore} from '@/libs/auth/+store/store';
import {AuthGetter} from '@/libs/auth/models/auth-state';
import {Constants} from '@/constants';
import {cloneDeep, isEqual} from 'lodash';
import moment from 'moment';
import {workTaskStatementsStore} from '@/libs/work-task-statements/+state/store';
import {visitRulesStore} from "@/libs/visit-rules/+state/store";
import {tenantsStore} from "@/libs/tenants/+state/store";

@Component({})
export default class WorkTaskRuleDialog extends Page {

    dialog = false;
    valid = false;
    saving = false;
    tableHeaders = [
        { text: "Název", value: "name", align: "left" },
        { text: "", value: "id", align: "right" }
    ];
    item: WorkTaskRuleModel | null = null;
    itemOriginal: WorkTaskRuleModel | null = null;
    partyId: string | null = null;
    editableState = false;
    basicRules = [
        (v: any) => !!v || this.translate('validation.thisFieldIsRequired')
    ];
    unsavedDialog = false;
    changed = false;
    deleteDialogLoading = false;
    deleteDialog = false;
    deleteDialogStatementsExists = false;
    deleting = false;
    cantDeleteDueToVisits = false;

    @Prop() id!: string;
    @Prop() readOnlyMode!: boolean;

    @Ref() form!: any;

    @Watch("item", { immediate: true, deep: true })
    itemChanged(v: WorkTaskRuleModel | null) {
        if (v && this.itemOriginal) {
            let original = cloneDeep(this.itemOriginal);
            if (original) {
                original.startDate = original.startDate !== undefined ? moment(original.startDate).format("YYYY-MM-DD") : null;
                original.endDate = original.endDate !== undefined ? moment(original.endDate).format("YYYY-MM-DD") : null;
            }
            let newItem = cloneDeep(v);
            if (newItem) {
                newItem.startDate = newItem.startDate !== undefined ? moment(newItem.startDate).format("YYYY-MM-DD") : null;
                newItem.endDate = newItem.endDate !== undefined ? moment(newItem.endDate).format("YYYY-MM-DD") : null;
            }

            if (!isEqual(newItem, original)) {
                this.changed = true;
            } else {
                this.changed = false;
            }
        }
    }

    @Watch("item.workTaskStateId")
    workTaskStateIdChanged (v: string, p: string) {
        if (v == Constants.WorkTaskRuleNotActiveId && p != Constants.WorkTaskRuleNotActiveId) {
            if (this.item!.endDate == null || moment(this.item?.endDate).startOf("day").isAfter(moment().startOf("day"))) {
                this.item!.endDate = moment().add(1, "day").format("yyyy-MM-DDT00:00:00");
            }
        }
    }

    get tenantId(): string | null {
        return authStore.useGetter(AuthGetter.GetTenant);
    }

    get party(): PartyModel {
        return partiesStore.useGetter(CrudGetter.Detail, this.partyId);
    }

    get readonly (): boolean {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        const tenant = tenantsStore.useGetter(CrudGetter.Detail, this.tenantId) as TenantModel;
        const party = partiesStore.useGetter(CrudGetter.Detail, this.partyId) as PartyModel;
        const enableWorkTaskRuleCreate = tenantUser.accountType == AccountTypeEnum.Admin || tenantUser.accountType == AccountTypeEnum.Manager || (tenantUser.accountType == AccountTypeEnum.Worker && tenant.enableCreateWorkTaskRuleByWorker == true);
        if (!enableWorkTaskRuleCreate) {
            return true;
        }
        if (this.readOnlyMode) {
            return true;
        } else {
            const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
            if (tenantUser.accountType == AccountTypeEnum.Volunteer) {
                return true;
            }
            else if (tenantUser.accountType == AccountTypeEnum.Worker) {
                if (tenant.enableEditClientByWorker && party.mainCareProviderId == tenantUser.userId) {
                    return false;
                }
                else if (tenant.enableEditClientOfAnotherWorkers && party.districtId == tenantUser.mainDistrictId) {
                    return false;
                }
                else {
                    return true;
                }
            }
            return false;
        }
    }

    get printing(): boolean {
        return workTaskRulesStore.useGetter(CrudGetter.Printing);
    }
    get isNew(): boolean {
        return this.item?.id == Guid.EmptyGuid();
    }

    get exceptWorkTaskStates(): string[] {
        if (this.itemOriginal?.workTaskStateId != Constants.WorkTaskRuleNewId) {
            return [    
                Constants.WorkTaskRuleNewId
            ];
        }
        else {
            return [];
        }
    }

    open (id: string, partyId: string, readOnlyMode = false) {
        this.readOnlyMode = readOnlyMode;
        this.item = null;
        this.dialog = true;
        partiesStore.dispatch(CrudAction.Get, { id: partyId });
        workTaskRulesStore.dispatch(CrudAction.Get, { id: id });
        this.editableState = true;
        this.subscribe(workTaskRulesStore, CrudReponse.Get).then((e: WorkTaskRuleModel) => {
            this.item = e;
            this.itemOriginal = cloneDeep(e);
        });
    }

    create (id: string, partyId: string, editableState = true) {
        this.readOnlyMode = false;
        this.editableState = editableState;
        partiesStore.dispatch(CrudAction.Get, { id: partyId });
        catalogueItemsStore.dispatch(CrudAction.Get, { id: id });
        this.subscribe(catalogueItemsStore, CrudReponse.Get).then((e: WorkTaskRuleModel) => {
            this.dialog = true;
            this.item = {
                id: Guid.EmptyGuid(),
                catalogueItemId: id,
                catalogueItem: e,
                frequency: FrequencyEnum.Regular,
                partyId: partyId,
                startDate: undefined,
                endDate: undefined,
                workTaskStateId: Constants.WorkTaskRuleNewId
            } as WorkTaskRuleModel;
            this.itemOriginal = cloneDeep(this.item);
        });
    }

    addClick (item: CatalogueItemModel) {
        console.log(item);
    }

    save () {
        if (this.form.validate()) {
            this.saving = true;
            if (this.item!.id == Guid.EmptyGuid()) {
                workTaskRulesStore.dispatch(CrudAction.Create, { item: this.item });
                this.subscribe(workTaskRulesStore, CrudReponse.Create).then((e: PartyModel) => {
                    this.saving = false;
                    this.$emit("saved");
                    this.dialog = false;
                }).catch((e: any) => {
                    this.saving = false;
                });
            }
            else {
                workTaskRulesStore.dispatch(CrudAction.Update, { item: this.item });
                this.subscribe(workTaskRulesStore, CrudReponse.Update).then((e: PartyModel) => {
                    this.saving = false;
                    this.$emit("saved");
                    this.dialog = false;
                }).catch((e: any) => {
                    this.saving = false;
                });
            }
        }
    }

    close () {
        if (!this.changed)
            this.dialog = false;
        else 
            this.unsavedDialog = true;
    }

    deleteItemClick () {
        this.deleteDialogLoading = true;
        workTaskStatementsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<WorkTaskStatementModel>(undefined, [
            { field: "workTask.workTaskRuleId", op: "eq", comparand: this.item!.id! }
        ], { pageIndex: 1, pageSize: 1 }, false, "WorkTaskRuleDeleteCheck"));
        this.subscribe(workTaskStatementsStore, CrudReponse.GetAll, "WorkTaskRuleDeleteCheck").then((e: WorkTaskStatementModel[]) => {
            this.deleteDialogLoading = false;
            if (e.length > 0) {
                this.deleteDialogStatementsExists = true;
            }
            else {
                this.deleteDialog = true;
            }
        }).catch((e) => {
            console.error(e);
            this.deleteDialogLoading = false;
            this.deleteDialog = false;
        });
    }

    deleteItem () {
        this.cantDeleteDueToVisits = false;
        visitRulesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<VisitRuleModel>(undefined, [
          { field: "visitRuleWorkTasks.workTaskRuleId", op: "eq", comparand: this.item!.id! },
          { field: "partyId", op: "eq", comparand: this.item!.partyId! }
        ], { pageIndex: 1, pageSize: 1 }, false, "CheckExistingWorkTaskRuleInVisits"));
        this.deleting = true;
        this.subscribe(visitRulesStore, CrudReponse.GetAll, "CheckExistingWorkTaskRuleInVisits").then((x: VisitRuleModel[]) => {
          if (x.count() == 0) {
            workTaskRulesStore.dispatch(CrudAction.Delete, { id: this.item!.id });
            this.subscribe(workTaskRulesStore, CrudReponse.Delete).then((e: any) => {
              this.deleting = false;
              this.deleteDialog = false;
              this.dialog = false;
            }).catch((e: any) => {
              this.deleting = false;
            });
          }
          else {
            this.deleteDialog = false;
            this.cantDeleteDueToVisits = true;
            this.deleting = false;
          }
        });
    }

    printClick () {
        workTaskRulesStore.dispatch(CrudAction.Print, { id: this.item!.id })
    }

}
